// extracted by mini-css-extract-plugin
export default {"section":"Ingredients_section__+ouOv"};